/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import { setDeviceLoginRequestAction, setIsConnectedAction, setInitialMigrattionDataAction } from "./actions";

const migrationSlice = createSlice({
  name: "migration",
  initialState,
  reducers: {
    setDeviceLoginRequest: setDeviceLoginRequestAction,
    setIsConnected: setIsConnectedAction,
    setInitialMigrattionData: setInitialMigrattionDataAction,
  },
});
export const MigrationReducers = migrationSlice.reducer;
export const { setDeviceLoginRequest, setIsConnected, setInitialMigrattionData } = migrationSlice.actions;
